/**
 * Resource GraphQL Queries
 *
 * 7 queries for universal asset management:
 * - getResource (single)
 * - listResources (paginated)
 * - getResourcesByType
 * - getResourcesByStatus
 * - getAvailableResources
 * - getLifeCriticalResources
 * - getResourceUtilizationReport
 *
 * @see graphql_gateway/src/resource_api/resource_graphql.rs - Backend implementation
 */

import { gql } from '@apollo/client';
import {
  RESOURCE_FIELDS,
  RESOURCE_CONNECTION_FIELDS,
  RESOURCE_UTILIZATION_REPORT_FIELDS,
} from './fragments';

/** Get resource by ID */
export const GET_RESOURCE = gql`
  ${RESOURCE_FIELDS}
  query GetResource($tenantId: String!, $resourceId: String!) {
    getResource(tenantId: $tenantId, resourceId: $resourceId) {
      ...ResourceFields
    }
  }
`;

/** List resources for tenant with pagination */
export const LIST_RESOURCES = gql`
  ${RESOURCE_CONNECTION_FIELDS}
  query ListResources($tenantId: String!, $limit: Int, $cursor: String) {
    listResources(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      ...ResourceConnectionFields
    }
  }
`;

/** Get resources by type (Physical, Digital, Human, Financial, Consumable, Shared) */
export const GET_RESOURCES_BY_TYPE = gql`
  ${RESOURCE_FIELDS}
  query GetResourcesByType($tenantId: String!, $resourceType: ResourceType!) {
    getResourcesByType(tenantId: $tenantId, resourceType: $resourceType) {
      ...ResourceFields
    }
  }
`;

/** Get resources by status (Available, InUse, Reserved, etc.) */
export const GET_RESOURCES_BY_STATUS = gql`
  ${RESOURCE_FIELDS}
  query GetResourcesByStatus($tenantId: String!, $status: ResourceStatus!) {
    getResourcesByStatus(tenantId: $tenantId, status: $status) {
      ...ResourceFields
    }
  }
`;

/** Get all available resources for tenant */
export const GET_AVAILABLE_RESOURCES = gql`
  ${RESOURCE_FIELDS}
  query GetAvailableResources($tenantId: String!) {
    getAvailableResources(tenantId: $tenantId) {
      ...ResourceFields
    }
  }
`;

/** Get life-critical resources (medical equipment, safety systems, etc.) */
export const GET_LIFE_CRITICAL_RESOURCES = gql`
  ${RESOURCE_FIELDS}
  query GetLifeCriticalResources($tenantId: String!) {
    getLifeCriticalResources(tenantId: $tenantId) {
      ...ResourceFields
    }
  }
`;

/** Get resource utilization report */
export const GET_RESOURCE_UTILIZATION_REPORT = gql`
  ${RESOURCE_UTILIZATION_REPORT_FIELDS}
  query GetResourceUtilizationReport($tenantId: String!, $resourceId: String!) {
    getResourceUtilizationReport(tenantId: $tenantId, resourceId: $resourceId) {
      ...ResourceUtilizationReportFields
    }
  }
`;
